import { createSaleDetailState } from '@/composables/sales/saleDetail/state';
import { saleDetailComputed } from '@/composables/sales/saleDetail/computed';
import { saleDetailCoreMethods } from '@/composables/sales/saleDetail/methods/core';
import { saleDetailExpenseMethods } from '@/composables/sales/saleDetail/methods/expenses';
import { saleDetailFeeMethods } from '@/composables/sales/saleDetail/methods/fees';

export { createSaleDetailState, saleDetailComputed };

export const saleDetailMethods = {
  ...saleDetailCoreMethods,
  ...saleDetailExpenseMethods,
  ...saleDetailFeeMethods,
};
